import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';
import StyledMenu from './styledComponent';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import logout from '../../assets/logout.png'
import about from '../../assets/about.png'
import userprofile from '../../assets/userprofile.png'
import profileImage from '../../assets/profile_5.png'
import { Typography, Grid } from '@mui/material';

export default function Profile({ handleProfileClick,handleLogin }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfile = () => {
    setAnchorEl(null);
    handleProfileClick(true)
  }

  const handleLogOut = () => {
    setAnchorEl(null);
    handleLogin(false)
  }

  return (
    <div style={{ marginRight: '50px' }}>
      <Grid display='flex' className="profile">
      <Avatar alt="profile image" src={profileImage} /> 
      <Typography style={{margin:'12px 5px 0px 8px', fontFamily: 'Rubik'}}>Smith</Typography> 
      <KeyboardArrowDownIcon
        style ={{marginTop:'12px', color:'#0D5C75'}}
        id="demo-customized-button"
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
      />
  </Grid>

      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleProfile} disableRipple>
          <img style={{ marginRight: '10px' }} src={userprofile} alt="userprofile" />
          User Profile
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          <img style={{ marginRight: '10px' }} src={about} alt="about" />
          About
        </MenuItem>
        <Divider sx={{ my: 0.5 }} />
        <MenuItem onClick={handleLogOut} disableRipple>
          <img style={{ marginRight: '10px' }} src={logout} alt="logout" />
          Logout
        </MenuItem>
      </StyledMenu>
    </div>
  );
}
